module.exports = __webpack_public_path__ + "img/ic_inv.bc1e6f24.svg";